$(document).on('keyup', '.alertMaxWordCount', (e) => {
  const val = $(e.currentTarget).val();
  const maxWords = parseInt($(e.currentTarget).data('max-word-count'), 10);
  if (!!val && typeof val === 'string' && val.length > maxWords) {
    alert(`${maxWords}文字以下で入力してください。`);
    $(e.currentTarget).val(val.substr(0, maxWords));
  }
});
